const $ = window.jQuery;

$(function () {

    if (document.body.classList.contains('page-album-preview')) {
        let audioID = document.querySelector(".geoTargetingOn");
        // correct details
        let theatreLat = 51.51135989307188; 
        let theatreLon = -0.133846075362064;
        let userLat; 
        let userLon;  
    
        // Haversine formula to calculate distance between two coordinates
        function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
            const R = 6371000; // Radius of the Earth in meters
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = R * c; // Distance in meters
            return distance;
        }
    
        // Function to compare current location with target location
        function compareLocations() {
            navigator.geolocation.getCurrentPosition((position) => {
                userLat = position.coords.latitude;
                userLon = position.coords.longitude;
    
                const distance = getDistanceFromLatLonInMeters(userLat, userLon, theatreLat, theatreLon);
    
                if (audioID) {
                    if (distance <= 300) {
                        audioID.classList.remove("d-none");
                        clearInterval(locationInterval); // Clear interval if condition is met
                    } else {
                        audioID.classList.add("d-none");
                    }
                }
            }, (error) => {
                console.error("Error retrieving location:", error);
            });
        }
    
        // Run page load
        compareLocations();
    
        const locationInterval = setInterval(compareLocations, 5000);
    }
});
